import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import useAuthorization from "@hooks/useAuthorization";

import { ROUTES } from "@utils/constant";

const BANK_ID_LOGIN_REMINDER_RELEASE_DATE = "2025-01-19T09:00:00.000000Z";

export const useBankIDLoginReminderDialog = () => {
  const { isAdminUser } = useAuthorization();
  const history = useHistory();
  const { ssn, last_login_at } = useSelector(
    state => state.authReducer.userInfo
  );

  const [isBankIdReminderDialogVisible, setIsBankIdReminderDialogVisible] =
    React.useState(false);

  const userInfo = React.useMemo(() => {
    const isShownAlready = Boolean(
      localStorage.getItem("isBankIdReminderDialogShown")
    );

    if (!isShownAlready) {
      localStorage.setItem("isBankIdReminderDialogShown", true);
    }

    return { ssn, last_login_at, isShownAlready };
  }, [ssn, last_login_at]);

  React.useEffect(() => {
    const isBankIdLoginEnabled = userInfo.ssn !== null;
    const lastLoginDate = new Date(userInfo.last_login_at);
    const thresholdDate = new Date(BANK_ID_LOGIN_REMINDER_RELEASE_DATE);
    const needToShowBankIdLoginReminder = lastLoginDate < thresholdDate;

    const isVisible =
      !userInfo.isShownAlready &&
      !isBankIdLoginEnabled &&
      needToShowBankIdLoginReminder;

    setIsBankIdReminderDialogVisible(isVisible);
  }, [userInfo]);

  const handleCloseBankIdReminderDialog = () => {
    setIsBankIdReminderDialogVisible(false);
  };

  const handleRedirectToMyProfile = () => {
    handleCloseBankIdReminderDialog();

    const targetUrl = isAdminUser
      ? ROUTES.ADMIN_MY_PROFILE.URL
      : ROUTES.USER_PROFILE.URL;

    history.push(targetUrl);
  };

  return {
    isBankIdReminderDialogVisible,
    handleCloseBankIdReminderDialog,
    handleRedirectToMyProfile,
  };
};
